import { NavigationTypeAttributes } from '../../typings/navigation-type-attributes';

export abstract class AbstractDetailComponent<T = NavigationTypeAttributes> {
  abstract attributes: T;
}
